<div class="wrapper">
  <app-client-list-item-new
    *ngFor="let client of clients; let i = index"
    [client]="client"
    [even]="i % 2 === 0"
  ></app-client-list-item-new>
</div>
